import type { FieldConfig, FieldValue, FieldValues } from '@shared/types/interactiveFields';
import { DynamicFieldRenderer } from './DynamicFieldRenderer';

type Language = 'bg' | 'de' | 'en';

interface InteractiveFieldsFormProps {
  fields: FieldConfig[];
  values: FieldValues;
  onChange: (values: FieldValues) => void;
  errors?: Record<string, string>;
  disabled?: boolean;
  language: Language;
}

export function InteractiveFieldsForm({
  fields,
  values,
  onChange,
  errors = {},
  disabled,
  language,
}: InteractiveFieldsFormProps) {
  const sortedFields = [...fields].sort((a, b) => a.order - b.order);

  const handleFieldChange = (fieldId: string, value: FieldValue) => {
    onChange({
      ...values,
      [fieldId]: value,
    });
  };

  return (
    <div className="space-y-6">
      {sortedFields.map((field) => (
        <DynamicFieldRenderer
          key={field.id}
          field={field}
          value={values[field.id]}
          onChange={(value) => handleFieldChange(field.id, value)}
          error={errors[field.id]}
          disabled={disabled}
          language={language}
        />
      ))}
    </div>
  );
}
